module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timer-holder"
  }, [_c('div', {
    staticClass: "center-content"
  }, [_c('svg', {
    staticClass: "timer",
    attrs: {
      "viewBox": "0 0 200 200",
      "preserveAspectRatio": "xMinYMin meet",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "bigCircle",
    attrs: {
      "r": "100",
      "cx": "100",
      "cy": "100"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "smallCircle",
    attrs: {
      "r": "90",
      "cx": "100",
      "cy": "100"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "segment",
    attrs: {
      "d": _vm.path
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.text != '') ? _c('text', {
    staticClass: "text",
    attrs: {
      "x": "100",
      "y": "100"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425b1ed4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timer/SvgCircleSector.vue
// module id = 52
// module chunks = 0